import { Home, Refresh } from '@mui/icons-material';
import { Box, Button, Card, Container, FormControl, Grid, Icon, IconButton, Input, InputAdornment, InputBase, InputLabel, Stack, Switch, TextField, Typography, alpha, styled, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import * as yup from 'yup';
import { Form, Formik, useFormik } from 'formik';
import FormikYup from './FormikYup';
import { InverterContext } from '../../../../../../context/InverterContext';
import { getDateTimeForPvParameter } from '../../../../../../utils';
import Loading from '../../../../../../components/loading/Loading';
import DataNotFound from '../../../../../../components/error/DataNotFound';

function SetValuesTabContent() {
    const { spacing, typography, palette } = useTheme()
    const { getHYBRDsetValues, HYBRD_SET_VALUES_DATA, HYBRD_SETVALUE_LOADING } = useContext(InverterContext)
    const LOGIN_ID = localStorage.getItem('LoginID')
    const LOC_CODE = localStorage.getItem('LCODE')
    const [DT1, setDT1] = useState(getDateTimeForPvParameter().LastDay)
    const [DT2, setDT2] = useState(getDateTimeForPvParameter().Today)
    const PASS_KEY = "XXXXXXXXXXXX"
    const PASS_KEY1 = "xyz"
    const WEB_KEY1 = "WEBXYZ321"
    const WEB_KEY = "WEBXYZABC"
    const IROW = 1
    const TYP = "WRITE"
    // const [TYP, setTYP] = useState('FLAG');
    // console.log('DATA', HYBRD_SET_VALUES_DATA)
    useEffect(() => {
        getHYBRDsetValues(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT2, DT2)
    }, [TYP])


    function onRefreshClickHandler() {
        getHYBRDsetValues(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT2, DT2)
    }

    useEffect(() => {
        const intervalCall = setInterval(() => {
            getHYBRDsetValues(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT2, DT2)
        }, 60000);
        return () => {
            // clean up
            clearInterval(intervalCall);
        };
    }, []);

    const validationSchema = yup.object({
        ForceDG: yup.number().typeError('It must be a number').required(),
        DGRuntime: yup.number().typeError('It must be a number').required(),
        DGStartVoltage: yup.number().typeError('It must be a number').required(),
        AbsorptionTime: yup.number().typeError('It must be a number').required(),
        BulkVoltage: yup.number().typeError('It must be a number').required(),
        FloatVoltage: yup.number().typeError('It must be a number').required(),
        LowCutoff: yup.number().typeError('It must be a number').required(),
        AcChargerStartVoltage: yup.number().typeError('It must be a number').required(),
        AcChargerStopVoltage: yup.number().typeError('It must be a number').required(),
        MinLoadThreshold: yup.number().typeError('It must be a number').required(),
        ExportPowerLimit: yup.number().typeError('It must be a number').required(),
        BatteryAh: yup.number().typeError('It must be a number').required(),
        BatteryChargingCurrent: yup.number().typeError('It must be a number').required(),
        MPPTMode: yup.number().typeError('It must be a number').required(),
        INVMode: yup.number().typeError('It must be a number').required(),
        Key: yup.number().typeError('It must be a number').required(),
        BatteryLowAlarm: yup.number().typeError('It must be a number').required(),
        ExportStartLevel: yup.number().typeError('It must be a number').required(),
        ExportStopLevel: yup.number().typeError('It must be a number').required()
    });

    return (
        <Box>
            <Stack direction={'row'} py={spacing(1)} justifyContent={'end'}>
                <Button type='submit' onClick={onRefreshClickHandler} startIcon={<Refresh />} variant='contained'>Refresh</Button>
            </Stack>
            {
                HYBRD_SETVALUE_LOADING ? <Loading /> :
                    HYBRD_SET_VALUES_DATA == null ? <DataNotFound /> :

                        <Formik
                            initialValues={{
                                ForceDG: '',
                                DGRuntime: HYBRD_SET_VALUES_DATA?.DG_RUN_TIME_MIN,
                                DGStartVoltage: HYBRD_SET_VALUES_DATA?.DG_START_VOLTAGE_V,
                                AbsorptionTime: HYBRD_SET_VALUES_DATA?.ABSORPTION_TIME_MIN,
                                BulkVoltage: HYBRD_SET_VALUES_DATA?.BULK_VOLTAGE_V,
                                FloatVoltage: HYBRD_SET_VALUES_DATA?.FLOAT_VOLTAGE_V,
                                LowCutoff: HYBRD_SET_VALUES_DATA?.LOW_CUTOFF_V,
                                AcChargerStartVoltage: HYBRD_SET_VALUES_DATA?.AC_CHARGER_START_VOLTAGE_V,
                                AcChargerStopVoltage: HYBRD_SET_VALUES_DATA?.AC_CHARGER_STOP_VOLTAGE_V,
                                MinLoadThreshold: HYBRD_SET_VALUES_DATA?.MIN_LOAD_THRESHOLD_W,
                                ExportPowerLimit: HYBRD_SET_VALUES_DATA?.EXPORT_POWER_LIMIT_PERCENT,
                                BatteryAh: HYBRD_SET_VALUES_DATA?.BATTERY_AH,
                                BatteryChargingCurrent: HYBRD_SET_VALUES_DATA?.BATTERY_CHARGING_CURRENT_A,
                                MPPTMode: HYBRD_SET_VALUES_DATA?.MPPT_MODE,
                                INVMode: HYBRD_SET_VALUES_DATA?.INV_MODE,
                                Key: HYBRD_SET_VALUES_DATA?.KEY_CODE,
                                BatteryLowAlarm: HYBRD_SET_VALUES_DATA?.BATTERY_LOW_ALARM,
                                ExportStartLevel: HYBRD_SET_VALUES_DATA?.EXPORT_START_LEVEL,
                                ExportStopLevel: HYBRD_SET_VALUES_DATA?.EXPORT_STOP_LEVEL
                            }}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                alert(JSON.stringify(values, null, 2));
                                setSubmitting(false)
                            }}
                        >
                            {(formik) => (

                                <Form>
                                    <Grid spacing={spacing(1)} container>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Force DG Start/Stop</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }}
                                                        id="ForceDG"
                                                        name="ForceDG"
                                                        value={formik.values.ForceDG}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.ForceDG && Boolean(formik.errors.ForceDG)}
                                                        helperText={formik.touched.ForceDG && formik.errors.ForceDG}
                                                    />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>DG Run time (Min)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField
                                                        style={{ fontSize: typography.body1.fontSize }}
                                                        id="DGRuntime"
                                                        name="DGRuntime"
                                                        value={formik.values.DGRuntime}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.DGRuntime && Boolean(formik.errors.DGRuntime)}
                                                        helperText={formik.touched.DGRuntime && formik.errors.DGRuntime}
                                                    />

                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>DG Start Voltage (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField
                                                        style={{ fontSize: typography.body1.fontSize }}
                                                        id="DGStartVoltage"
                                                        name="DGStartVoltage"
                                                        value={formik.values.DGStartVoltage}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.DGStartVoltage && Boolean(formik.errors.DGStartVoltage)}
                                                        helperText={formik.touched.DGStartVoltage && formik.errors.DGStartVoltage}
                                                    />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Absorption time (Min)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField
                                                        style={{ fontSize: typography.body1.fontSize }}
                                                        id="AbsorptionTime"
                                                        name="AbsorptionTime"
                                                        value={formik.values.AbsorptionTime}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.AbsorptionTime && Boolean(formik.errors.AbsorptionTime)}
                                                        helperText={formik.touched.AbsorptionTime && formik.errors.AbsorptionTime}
                                                    />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Bulk Voltage (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField
                                                        style={{ fontSize: typography.body1.fontSize }}
                                                        id="BulkVoltage"
                                                        name="BulkVoltage"
                                                        value={formik.values.BulkVoltage}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.BulkVoltage && Boolean(formik.errors.BulkVoltage)}
                                                        helperText={formik.touched.BulkVoltage && formik.errors.BulkVoltage}
                                                    />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Float Voltage (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="FloatVoltage"
                                                        name="FloatVoltage"
                                                        value={formik.values.FloatVoltage}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.FloatVoltage && Boolean(formik.errors.FloatVoltage)}
                                                        helperText={formik.touched.FloatVoltage && formik.errors.FloatVoltage} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Low Cut-off (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="LowCutoff"
                                                        name="LowCutoff"
                                                        value={formik.values.LowCutoff}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.LowCutoff && Boolean(formik.errors.LowCutoff)}
                                                        helperText={formik.touched.LowCutoff && formik.errors.LowCutoff} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Ac Charger Start Voltage (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="AcChargerStartVoltage"
                                                        name="AcChargerStartVoltage"
                                                        value={formik.values.AcChargerStartVoltage}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.AcChargerStartVoltage && Boolean(formik.errors.AcChargerStartVoltage)}
                                                        helperText={formik.touched.AcChargerStartVoltage && formik.errors.AcChargerStartVoltage} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Ac Charger Stop Voltage (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="AcChargerStopVoltage"
                                                        name="AcChargerStopVoltage"
                                                        value={formik.values.AcChargerStopVoltage}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.AcChargerStopVoltage && Boolean(formik.errors.AcChargerStopVoltage)}
                                                        helperText={formik.touched.AcChargerStopVoltage && formik.errors.AcChargerStopVoltage} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Min Load Threshold (W)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="MinLoadThreshold"
                                                        name="MinLoadThreshold"
                                                        value={formik.values.MinLoadThreshold}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.MinLoadThreshold && Boolean(formik.errors.MinLoadThreshold)}
                                                        helperText={formik.touched.MinLoadThreshold && formik.errors.MinLoadThreshold} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Export power limit (%)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="ExportPowerLimit"
                                                        name="ExportPowerLimit"
                                                        value={formik.values.ExportPowerLimit}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.ExportPowerLimit && Boolean(formik.errors.ExportPowerLimit)}
                                                        helperText={formik.touched.ExportPowerLimit && formik.errors.ExportPowerLimit} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Battery Ah</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="BatteryAh"
                                                        name="BatteryAh"
                                                        value={formik.values.BatteryAh}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.BatteryAh && Boolean(formik.errors.BatteryAh)}
                                                        helperText={formik.touched.BatteryAh && formik.errors.BatteryAh} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Battery Charging Current (A)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="BatteryChargingCurrent"
                                                        name="BatteryChargingCurrent"
                                                        value={formik.values.BatteryChargingCurrent}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.BatteryChargingCurrent && Boolean(formik.errors.BatteryChargingCurrent)}
                                                        helperText={formik.touched.BatteryChargingCurrent && formik.errors.BatteryChargingCurrent} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>MPPT Mode</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="MPPTMode"
                                                        name="MPPTMode"
                                                        value={formik.values.MPPTMode}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.MPPTMode && Boolean(formik.errors.MPPTMode)}
                                                        helperText={formik.touched.MPPTMode && formik.errors.MPPTMode} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>INV Mode</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="INVMode"
                                                        name="INVMode"
                                                        value={formik.values.INVMode}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.INVMode && Boolean(formik.errors.INVMode)}
                                                        helperText={formik.touched.INVMode && formik.errors.INVMode} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Key</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="Key"
                                                        name="Key"
                                                        value={formik.values.Key}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.Key && Boolean(formik.errors.Key)}
                                                        helperText={formik.touched.Key && formik.errors.Key} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Battery Low Alarm (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="BatteryLowAlarm"
                                                        name="BatteryLowAlarm"
                                                        value={formik.values.BatteryLowAlarm}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.BatteryLowAlarm && Boolean(formik.errors.BatteryLowAlarm)}
                                                        helperText={formik.touched.BatteryLowAlarm && formik.errors.BatteryLowAlarm} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Export start level (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="ExportStartLevel"
                                                        name="ExportStartLevel"
                                                        value={formik.values.ExportStartLevel}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.ExportStartLevel && Boolean(formik.errors.ExportStartLevel)}
                                                        helperText={formik.touched.ExportStartLevel && formik.errors.ExportStartLevel} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <Typography variant='body2'>Export stop level (V)</Typography>
                                                <FormControl variant="standard">
                                                    <TextField style={{ fontSize: typography.body1.fontSize }} id="ExportStopLevel"
                                                        name="ExportStopLevel"
                                                        value={formik.values.ExportStopLevel}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.ExportStopLevel && Boolean(formik.errors.ExportStopLevel)}
                                                        helperText={formik.touched.ExportStopLevel && formik.errors.ExportStopLevel} />
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                    </Grid>


                                    <Stack direction={'row'} columnGap={spacing(1)} justifyContent={'end'}>
                                        <Button type='submit'
                                            disabled={formik.isSubmitting}
                                            variant='contained'
                                        >
                                            {formik.isSubmitting
                                                ? "Submitting..."
                                                : "Submit"}
                                        </Button>
                                        <Button type='reset' variant='contained' color='error'>Close</Button>
                                    </Stack>
                                </Form>
                            )}
                        </Formik>

            }


        </Box >
    )
}

export default SetValuesTabContent
